"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HqoClientSdk = void 0;
var mockedSdk_1 = require("../mockedSdk");
var parse_event_utils_1 = require("./parse-event.utils");
var sdk_constants_1 = require("./sdk.constants");
var sdk_message_types_1 = require("./types/sdk-message.types");
var utils_1 = require("./utils");
var HqoClientSdk = (function () {
    function HqoClientSdk(_a) {
        var _this = this;
        var app_uuid = _a.app_uuid, develop = _a.develop, _b = _a.init, init = _b === void 0 ? true : _b, _c = _a.init_timeout, init_timeout = _c === void 0 ? 0 : _c;
        this.identity = {
            getJWT: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.GET_JWT);
            },
            getUser: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.GET_USER);
            },
            getBuilding: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.GET_BUILDING);
            },
            getBuildings: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.GET_BUILDINGS);
            },
            getBrand: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.GET_BRAND);
            },
            getTheme: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.GET_THEME);
            },
        };
        this.host = {
            getInfo: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.GET_HOST_INFO);
            },
        };
        this.header = {
            setHeader: function (header_title, work_mode, header_url, header_cta_icon) {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.SET_HEADER, { header_title: header_title, header_url: header_url, header_cta_icon: header_cta_icon, work_mode: work_mode });
            },
            showHeader: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.SHOW_HEADER);
            },
            hideHeader: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.HIDE_HEADER);
            },
        };
        this.footer = {
            showFooter: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.SHOW_FOOTER);
            },
            hideFooter: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.HIDE_FOOTER);
            },
        };
        this.swipe = {
            enableBackSwipe: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.ENABLE_BACK_SWIPE);
            },
            disableBackSwipe: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.DISABLE_BACK_SWIPE);
            },
        };
        this.payments = {
            showNativePayment: function (_type, config, gatewayId) {
                if (gatewayId === void 0) { gatewayId = sdk_constants_1.DEFAULT_GATEWAY_ID; }
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.SHOW_NATIVE_PAYMENT, {
                    CURRENCY: config.currency,
                    AUTHORIZATION_TOTAL: config.authorization_total,
                    SUBTOTAL: config.subtotal,
                    TAX: config.tax,
                    TOTAL: config.total,
                    payment_gateway_id: gatewayId,
                });
            },
            hideNativePayments: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.HIDE_NATIVE_PAYMENTS);
            },
            getPaymentMethods: function () {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.GET_PAYMENT_METHODS);
            },
            tokenizeCard: function (cardId, gatewayId) {
                if (gatewayId === void 0) { gatewayId = sdk_constants_1.DEFAULT_GATEWAY_ID; }
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.TOKENIZE_CARD, {
                    card_id: parseInt(cardId === null || cardId === void 0 ? void 0 : cardId.toString(), 10),
                    gateway_id: gatewayId,
                });
            },
            showNativePaymentAuthorization: function (type, config) {
                _this.payments.showNativePayment(type, config);
            },
        };
        this.storage = {
            get: function (key) {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.GET_STORAGE, { key: key });
            },
            set: function (key, value) {
                _this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.SET_STORAGE, {
                    key: key,
                    value: typeof value !== 'string' ? JSON.stringify(value) : value,
                });
            },
        };
        this.on = function (eventName, handler) {
            var _a;
            if (!_this.handlers[eventName]) {
                _this.handlers[eventName] = [];
            }
            (_a = _this.handlers[eventName]) === null || _a === void 0 ? void 0 : _a.push(handler);
        };
        this.developerMocked = function (action) {
            var mockedSdk = new mockedSdk_1.MockedSdk();
            switch (action) {
                case sdk_message_types_1.HQO_SDK_ACTIONS.GET_JWT:
                    return mockedSdk.getJWT();
                case sdk_message_types_1.HQO_SDK_ACTIONS.GET_USER:
                    return mockedSdk.getUser();
                case sdk_message_types_1.HQO_SDK_ACTIONS.INIT:
                    return mockedSdk.init();
                case sdk_message_types_1.HQO_SDK_ACTIONS.GET_HOST_INFO:
                    return mockedSdk.getHostInfo();
                case sdk_message_types_1.HQO_SDK_ACTIONS.GET_BUILDING:
                    return mockedSdk.getBuilding();
                case sdk_message_types_1.HQO_SDK_ACTIONS.GET_BUILDINGS:
                    return mockedSdk.getBuildings();
                case sdk_message_types_1.HQO_SDK_ACTIONS.TOKENIZE_CARD:
                    return mockedSdk.getTokenizeCard();
                case sdk_message_types_1.HQO_SDK_ACTIONS.GET_THEME:
                    return mockedSdk.getTheme();
                case sdk_message_types_1.HQO_SDK_ACTIONS.GET_BRAND:
                    return mockedSdk.getBrand();
                default:
                    return new Error('Unknown action');
            }
        };
        this.broadcast = function (name, data) {
            if (name === void 0) { name = ''; }
            if (data === void 0) { data = {}; }
            setTimeout(function () {
                var myCustomEvent = new CustomEvent(sdk_constants_1.HQO_SDK_EVENT_NAME, { detail: { event: name, data: data } });
                window.dispatchEvent(myCustomEvent);
            }, 0);
        };
        this.emit = function (event) {
            var detail = event.detail;
            _this.handleEvent(detail);
        };
        this.handleMessage = function (event) {
            var detail = (0, parse_event_utils_1.parseMessageEvent)(event);
            _this.handleEvent(detail);
        };
        this.appUuid = app_uuid;
        this.handlers = {};
        this.developerMode = develop;
        this.initTimeout = init_timeout * sdk_constants_1.SECONDS_MULTIPLIER || sdk_constants_1.DEFAULT_INIT_TIMEOUT;
        this.initComplete = false;
        if (window.addEventListener) {
            window.addEventListener(sdk_constants_1.HQO_SDK_EVENT_NAME, this.emit, false);
            window.addEventListener(sdk_constants_1.WINDOW_POST_MESSAGE_EVENT_NAME, this.handleMessage, false);
        }
        else {
            window.attachEvent(sdk_constants_1.HQO_SDK_EVENT_NAME, this.emit);
            window.attachEvent(sdk_constants_1.WINDOW_POST_MESSAGE_EVENT_NAME, this.handleMessage);
        }
        if (init) {
            this.init();
        }
    }
    HqoClientSdk.prototype.getInstance = function () {
        return this.appUuid;
    };
    HqoClientSdk.prototype.init = function () {
        var _this = this;
        this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.INIT, { app_uuid: this.appUuid });
        setTimeout(function () {
            _this.initConfirmation();
        }, this.initTimeout);
    };
    HqoClientSdk.prototype.close = function () {
        this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.CLOSE_WEB_VIEW);
    };
    HqoClientSdk.prototype.logout = function () {
        this.postMessage(sdk_message_types_1.HQO_SDK_ACTIONS.LOGOUT);
    };
    HqoClientSdk.prototype.initConfirmation = function () {
        var fullUrl = new URL(window.location.href);
        var params = fullUrl.searchParams;
        var isEmbedVersion = params.get(sdk_constants_1.EMBED_PARAMETER_NAME);
        if (!this.initComplete && isEmbedVersion) {
            params.delete(sdk_constants_1.EMBED_PARAMETER_NAME);
            var redirectUrl = fullUrl.toString();
            this.broadcast((0, utils_1.response)(sdk_message_types_1.HQO_SDK_ACTIONS.INIT), { url_reload: redirectUrl, error: sdk_constants_1.INIT_TIMEOUT_MESSAGE });
            window.location.replace(redirectUrl);
        }
    };
    HqoClientSdk.prototype.postMessage = function (action, data) {
        this.postMessageToIos(action, data);
        this.postMessageToAndroid(action, data);
        this.postMessageToWeb(action, data);
        if (this.developerMode) {
            var mockedData = this.developerMocked(action);
            this.broadcast("".concat(action).concat(sdk_constants_1.HQO_SDK_EVENT_SUFFIX), mockedData);
        }
    };
    HqoClientSdk.prototype.postMessageToIos = function (action, data) {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[action]) {
            window.webkit.messageHandlers[action].postMessage(data);
        }
    };
    HqoClientSdk.prototype.postMessageToAndroid = function (action, data) {
        try {
            if (typeof Android !== 'undefined' && (Android === null || Android === void 0 ? void 0 : Android[action])) {
                Android[action](JSON.stringify(data));
            }
        }
        catch (error) {
            if (error instanceof Error) {
                console.warn("Could not post ".concat(action, " message: ").concat(error.message));
            }
        }
    };
    HqoClientSdk.prototype.postMessageToWeb = function (action, data) {
        var _a, _b, _c;
        try {
            var messageData = JSON.stringify({ action: action, data: data });
            var isOpenedInIframe = window.self !== window.top;
            if (isOpenedInIframe) {
                (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage(messageData, sdk_constants_1.POST_MESSAGE_TARGET_ORIGIN);
            }
            else {
                (_c = (_b = window.top) === null || _b === void 0 ? void 0 : _b.opener) === null || _c === void 0 ? void 0 : _c.postMessage(messageData, sdk_constants_1.POST_MESSAGE_TARGET_ORIGIN);
            }
        }
        catch (error) {
            if (error instanceof Error) {
                console.warn("Could not post ".concat(action, " message: ").concat(error.message));
            }
        }
    };
    HqoClientSdk.prototype.handleEvent = function (eventPayload) {
        var _a;
        var _b;
        var handlerPayload = eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.data;
        if ((eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.event) === (0, utils_1.response)(sdk_message_types_1.HQO_SDK_ACTIONS.INIT)) {
            this.initComplete = true;
        }
        if ((eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.event) === (0, utils_1.response)(sdk_message_types_1.HQO_SDK_ACTIONS.GET_STORAGE) && typeof (eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.data) === 'string') {
            var _c = JSON.parse(eventPayload.data), key = _c.key, value = _c.value;
            handlerPayload = (_a = {}, _a[key] = value, _a);
        }
        if ((eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.event) === (0, utils_1.response)(sdk_message_types_1.HQO_SDK_ACTIONS.GET_PAYMENT_METHODS) &&
            typeof (eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.data) === 'string') {
            var cards = JSON.parse(eventPayload.data).cards;
            handlerPayload = {
                apple_pay: false,
                google_pay: false,
                cards: cards.map(function (card) { return ({
                    card_last_four: card.last_four,
                    card_brand: card.card_type,
                    token_id: card.id,
                    token: card.token,
                }); }),
            };
        }
        if (typeof handlerPayload === 'string') {
            handlerPayload = (0, utils_1.parseJson)(handlerPayload);
        }
        if (eventPayload) {
            (_b = this.handlers[eventPayload.event]) === null || _b === void 0 ? void 0 : _b.forEach(function (handler) { return handler === null || handler === void 0 ? void 0 : handler(handlerPayload); });
        }
    };
    return HqoClientSdk;
}());
exports.HqoClientSdk = HqoClientSdk;
//# sourceMappingURL=sdk.js.map